<template>
  <v-container class="mt-0">
    <v-row justify="center">
      <v-col cols="6">
        <v-card elevation="15">
          <v-toolbar dense dark color="deep-orange darken-3">
            Nuevo usuario
            <v-spacer></v-spacer>
            <!-- BTN ATRAS -->
            <v-btn
              small
              class="ma-2"
              color="blue lighten-2"
              :to="{ name: 'catusuarios2' }"
              dark
            >
              <v-icon class="mx-2" small>mdi-reply</v-icon>
            </v-btn>
            <!-- BTN GUARDAR -->
            <v-btn
              small
              class="ma-2"
              :loading="loading"
              @click.prevent="saveinfo"
              color="success"
              >Grabar
            </v-btn>
          </v-toolbar>

          <v-row>
            <v-col cols="12">
              <v-card class="ma-2">
                <v-text-field
                  prepend-icon="mdi-account"
                  v-model="nomuser"
                  :counter="40"
                  label="Nombre"
                  required
                  dense
                  class="ma-4"
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  prepend-icon="mdi-email"
                  label="Email"
                  required
                  dense
                  class="ma-4"
                  type="text"
                >
                </v-text-field>

                <!--                   <v-text-field
                    v-model="nomplanta"
                    prepend-icon="mdi-home-city"
                    class="ma-3"
                    label="nomplanta">
                  </v-text-field>
 -->
                <leeplantas class="pa-2"></leeplantas>

                <!--  <v-text-field
                    v-model="nomarea"
                    prepend-icon="mdi-laptop"
                    class="ma-3"
                    label="nomarea">
                  </v-text-field>
 -->
                <leeareas class="pa-2"></leeareas>
                <v-text-field
                  v-model="nomina"
                  prepend-icon="mdi-book-edit-outline"
                  class="ma-3"
                  label="Nómina"
                >
                </v-text-field>

                <v-select
                  class="ma-3"
                  :items="nivel"
                  label="Nivel"
                  v-model="nivelactual"
                ></v-select>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import leeplantas from "@/components/leeplantas";
import leeareas from "@/components/leeareas";

export default {
  components: {
    leeplantas,
    leeareas,
  },
  data() {
    return {
      loading: false,
      nomuser: "",
      email: "",
      nomplanta: "",
      idplanta: 0,
      nomarea: "",
      idarea: 0,
      nomina: "",
      idusuarioweb: "",

      nivel: ["ADMIN", "  APP"],
      nivelactual: "  APP",

      rules: {
        required: (value) => !!value || "Requerido.",
        min: (v) => v.length >= 8 || "Minimo 8 caracteres",
        emailMatch: () => "El correo y/o la contraseña no son correctos",
      },

      NomlinRules: [
        (v) => !!v || "El nombre es requerido",
        (v) => v.length <= 30 || "El nombre debe ser menor de 30 letras",
      ],
    };
  },

  created() {
    // this.idcita = ''
    console.log("router", this.$route.params);
    this.nomuser = this.$route.params.nomuser;

    //MODO EDITAR
    if (this.nomuser !== undefined) {
      this.nModo = 2;
      this.readonly = true;
      this.cargarInfo(this.$route.params);
      this.modo = "Editar";
    } else {
      console.log("nuevo");
      //VALORES INICIALES ALTA
      this.nModo = 1;
      this.modo = "Nuevo";
    }
  },

  computed: {
    ...mapGetters("areas", ["getArea"]),
    ...mapGetters("plantas", ["getPlanta"]),

    validaInfo() {
      return this.nomuser !== "" && this.nomina !== "";
    },
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("areas", ["setArea"]),
    ...mapActions("plantas", ["setPlanta"]),

    cargarInfo(usuarios) {
      console.log("USUARIo", usuarios);
      this.nomuser = usuarios.nomuser;
      this.email = usuarios.email;

      this.idplanta = usuarios.idplanta;
      this.idarea = usuarios.idarea;

      this.email = usuarios.email;
      this.nivelactual = usuarios.nivel;
      this.nomina = usuarios.nomina;
      this.idusuariosweb = usuarios.idusuariosweb;

      //this.codplanta = planta.codplanta
      this.cargarArea();
      this.cargarPlanta();
    },

    cargarPlanta() {
      console.log("idplanta", this.idplanta);
      if (this.idplanta > 0) {
        this.$http
          .get("v2/get.planta/" + this.idplanta)
          .then((response) => {
            console.log("response", response);
            let oPlanta = {
              idplanta: this.idplanta,
              nomplanta: response.data.result.nomplanta,
            };

            console.log(oPlanta);
            this.setPlanta(oPlanta);
          })
          .catch((error) => {
            console.log(error);
            this.showSnack({
              text: "Problema para cargar planta" + error,
              color: "error",
              timeout: 2000,
            });
          });
      }
    },

    cargarArea() {
      console.log("idarea", this.idarea);
      if (this.idarea > 0) {
        this.$http
          .get("v2/get.area/" + this.idarea)
          .then((response) => {
            console.log("response", response);
            let oArea = {
              idarea: this.idarea,
              nomarea: response.data.result.nomarea,
            };
            console.log(oArea);
            this.setArea(oArea);
          })
          .catch((error) => {
            console.log(error);
            this.showSnack({
              text: "Problema para cargar planta" + error,
              color: "error",
              timeout: 2000,
            });
          });
      }
    },

    saveinfo() {
      console.log("saveInfo");
      if (!this.validaInfo) {
        this.showSnack({
          text: "Debes registrar el nombre y su número de nómina ",
          color: "orange",
          timeout: 2000,
        });
        return;
      }

      if (this.getPlanta.idplanta == 0) {
        this.idplanta = 0;
      } else {
        this.idplanta = parseInt(this.getPlanta.idplanta);
      }

      if (this.getArea.idarea == 0) {
        this.idarea = 0;
      } else {
        this.idarea = parseInt(this.getArea.idarea);
      }

      var payload = {
        nomuser: this.nomuser,
        email: this.email,
        nomina: this.nomina.padStart(10),
        idplanta: this.idplanta,
        idarea: this.idarea,
        nivel: this.nivelactual,
        estatus: 2,
        idusuarioweb: parseInt(this.idusuariosweb),
      };

      console.log("payload", payload);
      // this.addCita(payload)

      //NUEVO
      if (this.nModo == 1) {
        //Dedinir db name
        this.$http
          .post("v2/insert.usuario", payload)
          .then((response) => {
            console.log("response", response);
            this.limpiarUsuario();

            this.showSnack({
              text: "Usuarios agregada correctamente",
              color: "success",
              timeout: 2000,
            });

            setTimeout(() => this.$router.push({ name: "catusuarios2" }), 2000);
          })
          .catch((error) => {
            console.log(error);
            this.showSnack({
              text: "Problema para grabar" + error,
              color: "error",
              timeout: 2000,
            });
          });
      }

      //EDITAR
      if (this.nModo == 2) {
        this.$http
          .put("v2/update.usuario/" + this.idusuariosweb, payload)
          .then(() => {
            this.limpiarUsuario();

            this.showSnack({
              text: "Usuario grabado correctamente ",
              color: "success",
              timeout: 2000,
            });
            setTimeout(() => this.$router.push({ name: "catusuarios2" }), 2000);
          })
          .catch((error) => {
            // console.log("error", error.data)
            this.showSnack({
              text: "Problema para grabar  :" + error.data.message,
              color: "error",
              timeout: 2000,
            });
          });
      }
    },

    limpiarUsuario() {
      this.nomuser = "";
      this.nomina = "";
      this.nivelactual = "  APP";
      let oArea = {
        idarea: "0",
        nomarea: "",
      };
      this.setArea(oArea);

      let oPlanta = {
        idplanta: "0",
        nomplanta: "",
      };

      this.setPlanta(oPlanta);
    },
  },
};
</script>
